import { render, staticRenderFns } from "./StudentComments.vue?vue&type=template&id=a64fc4b8"
import script from "./StudentComments.vue?vue&type=script&lang=js"
export * from "./StudentComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports